import _angular from "./angular";
var exports = {};
_angular;
exports = angular;
export default exports;